import { render } from "./RbSidebar.vue?vue&type=template&id=83199820&scoped=true"
import script from "./RbSidebar.vue?vue&type=script&lang=js"
export * from "./RbSidebar.vue?vue&type=script&lang=js"

import "./RbSidebar.vue?vue&type=style&index=0&id=83199820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83199820"]])

export default __exports__